import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { TrafficProfileItem } from './components/TrafficProfileItem'

type Props = RenderItemProps<'trafficProfiles'>

export function Item(props: Props) {
  return props.type === 'item' ? <TrafficProfileItem {...props} /> : null
}
